import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
// import PasswordChecklist from 'react-password-checklist';
import LoginIcon from 'assets/Icons/loginIcons/loginIcon';
import Form from 'components/elements/Form/form';
import PasswordResetMessage from 'pages/PasswordResetMessage';
import { useParams } from 'react-router-dom';
import ResetPasswordService from 'services/hooks/reset-password-service';
import Input from 'components/elements/Form/Input/input';
import { useMutation, useQueryClient } from 'react-query';
import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';

interface ResetPasswordInterface {
  newPassword: string;
  confirmPassword: string;
}
// validation
const LoginSchema = yup.object().shape({
  newPassword: yup.string().required('New Password is required'),
  confirmPassword: yup.string().required('Confirm Password is required')
});

function ResetPasswordForm() {
  const { token } = useParams();
  const methods = useForm({ resolver: yupResolver(LoginSchema) });
  // const password = methods.watch('newPassword');
  // const confirmPassword = methods.watch('confirmPassword');
  // const [validToken, setValidToken] = React.useState(false);
  // const [validPassword, setValidPassword] = React.useState(false);
  const [complete, setComplete] = React.useState(false);
  const [error, setError] = React.useState('');
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(ResetPasswordService.passwordResetConfirm, {
    onSuccess: () => {
      setComplete(true);
    },
    onError: () => {
      setError('Something went wrong. Please try again or contact support if the issue persists.');
    },
    onSettled: () => {
      queryClient.invalidateQueries('create');
    }
  });

  const onSubmit = async (data: ResetPasswordInterface) => {
    if (token) {
      const userResetPassword = {
        token: token,
        newPassword: data.newPassword
      };
      mutate(userResetPassword);
    }
  };

  // React.useEffect(() => {
  //   async function verifyToken() {
  //     const response = await api.passwordResetVerify(uuid, token);
  //     if (response?.status === 200) {
  //       setValidToken(true);
  //     } else {
  //       setValidToken(false);
  //     }
  //   }
  //   verifyToken();
  // }, []);

  if (!complete) {
    return isLoading ? (
      <LoadingSpinner />
    ) : (
      <Form
        buttonLabel="Reset Password"
        // buttonDisabled={validPassword}
        icon={<LoginIcon />}
        methods={methods}
        onSubmit={onSubmit}
        styles="text-left"
      >
        <p>Enter a new password below to reset your log in credentials.</p>
        <Input
          label="New Password"
          name="newPassword"
          type="password"
          placeholder="*****"
          autoFocus
        />
        <Input
          label="Confirm New Password"
          name="confirmPassword"
          type="password"
          placeholder="*****"
        />
        {/* {password && (
          <PasswordChecklist
            rules={['minLength', 'specialChar', 'number', 'capital', 'match']}
            minLength={5}
            value={password}
            valueAgain={confirmPassword}
            onChange={(isValid) => {
              if (isValid) {
                setValidPassword(true);
              } else {
                setValidPassword(false);
              }
            }}
          />
        )} */}
        {error && <div className="flex text-secondary2">{error}</div>}
      </Form>
    );
  } else {
    return <PasswordResetMessage message="Password has been reset successfully. Please log in." />;
  }
}

export default ResetPasswordForm;
